import { Control, FieldError, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from 'components/Form/Input/Input/Input';

import { SsccSettingsFormState } from '../helpers';

type SerialNumberFieldProps = {
  control: Control<SsccSettingsFormState>;
  /** Whether a seed would actually be applied by the backend — see `canSeedCounter`. */
  seedable: boolean;
  counterValue: number | null;
  error?: FieldError;
  disabled: boolean;
};

/**
 * One field with two readings: normally it reports the live counter read-only, and inside the window where
 * a seed takes effect it clears and becomes the seed input. The counter is never written into the form, so
 * only a seed the user typed can be submitted.
 */
export const SerialNumberField = ({ control, seedable, counterValue, error, disabled }: SerialNumberFieldProps) => {
  const { t } = useTranslation();
  const { field } = useController({ name: 'generation.counter_seed', control });

  return (
    <Input
      label={
        seedable ? t('settings:ssccSettings.form.firstSerialNumber') : t('settings:ssccSettings.form.nextSerialNumber')
      }
      description={
        seedable
          ? t('settings:ssccSettings.form.firstSerialNumberSubtitle')
          : t('settings:ssccSettings.form.nextSerialNumberSubtitle')
      }
      placeholder={seedable ? undefined : (t('settings:ssccSettings.form.noSerialNumberYet') ?? '')}
      errors={error}
      disabled={!seedable || disabled}
      name={field.name}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={seedable ? field.value : (counterValue ?? '')}
    />
  );
};
